<template>
  <step :active="2"></step>
  <div class="topTxt" v-html="gconfig.SuccessPage"></div>
  <div class="successConV2">
    <div class="qrMain">
      <div class="qrbox">
        <qrcode-vue :value="visitorObj.VistorVisCard" :size="200"></qrcode-vue>
        <p class="codeTip">Show the QR code to sign in</p>
        <p class="codeTip">Sign in code:{{ visitorObj.VistorVisCard }}</p>
      </div>
    </div>
  </div>
  <div class="attendMsg">
    <div class="vMsg">
      <img :src="icon11" alt="" class="iconImg" />
      <div class="aBox">
        <h3>Attendee information</h3>
        <div class="aTxt">
          <span>Guest Name:</span>
          <span>{{ visitorObj.VisitorName }}</span>
        </div>
        <div class="aTxt">
          <span>Company Name:</span>
          <span>{{ visitorObj.VisitorComName }}</span>
        </div>
      </div>
    </div>
    <div class="eMsg">
      <img :src="hos1" alt="" class="iconImg" />
      <div class="aBox">
        <h3>{{ gconfig.ExhibitionName }}</h3>
        <div class="msgItem aTxt">
          <span>{{ gconfig.ExhibitionTime }}</span>
        </div>
        <div class="msgItem aTxt">
          <span>{{ gconfig.ExhibitionAddress }}</span>
        </div>
      </div>
    </div>
    <div class="checkMap">
      <b @click="toMap">Consult A Map</b>
    </div>
  </div>
  <div v-html="gconfig.SuccessPageBottomText"></div>
  <div class="shMask" v-show="showSh">
    <img :src="gconfig.Banner" style="width: 100%" alt="" />
    <div class="shConBox">
      <div class="shDiv">
        <img :src="shIcon" alt="" />
        <h3>Under review</h3>
        <div v-html="shContent" class="shTxt"></div>
      </div>
    </div>
  </div>
  <!-- 身份证 -->
  <div class="shMask" v-show="showVerCard">
    <img :src="gconfig.Banner" style="width: 100%" alt="" />
    <div>
      <p style="padding: 15vw 0 8vw; font-size: 1.2em; font-weight: 600">
        请您补充证件号码，完成实名认证！
      </p>
      <van-form @failed="onFailed" @submit="onSubmit">
        <van-cell-group>
          <!-- 姓名 -->
          <van-field
            v-model="formMg.Name"
            Name="Name"
            label="姓名"
            :rules="rulesAll.Name"
            class="requiredItem"
          />
          <!-- 身份证号 -->
          <van-field
            class="requiredItem"
            v-model="formMg.IDCardNo"
            Name="IDCardNo"
            label="身份证号"
            :rules="rulesAll.IDCardNo"
          />
        </van-cell-group>
        <div style="margin: 16px">
          <van-button
            round
            style="width: 45%"
            :color="mainColor"
            type="primary"
            native-type="submit"
            :disabled="btnLoading"
            :loading="btnLoading"
          >
            下一步
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>
<script setup>
import shIcon from '@/assets/shIcon.png'
import icon11 from '@/assets/icon11.png'
import hos1 from '@/assets/hos1.png'
import { ref, computed, onMounted } from 'vue'
import api from '@/api'
import { useStore } from 'vuex'
import QrcodeVue from 'qrcode.vue'
import step from '@/components/step.vue'
import wx from '@/utils/wx.js'
import { decryptionECB } from '@/utils/utils.js'
import { validatorName } from '@/utils/validators.js'
import { regCId } from '@/utils/regs.js'
import router from '../../router'
const store = useStore()
const ExhCode = computed(() => store.state.ExhCode)
const gconfig = computed(() => getConfigObj(store.state.gconfig))
const getConfigObj = (configStr) => {
  const configObj = {}
  if (configStr) {
    const resObj = JSON.parse(decryptionECB(configStr))
    resObj.forEach((item) => {
      configObj[item.GlobalKey] = item.GlobalEValue
    })
  }
  return configObj
}
const mainColor = computed(() => store.state.mainColor)
// console.log(gconfig.value, '222222222')
const VisitorID = computed(() => store.state.VisitorID)
const isWeX = computed(() => store.state.isWeX)
const visitorObj = ref({})
// 是否显示审核
const showSh = ref(false)
// 审核显示内容
const shContent = ref('')
const getMsg = async () => {
  const res = await api.getVisitorApi({ VisitorID: VisitorID.value })
  const jmRes = JSON.parse(decryptionECB(res.data))
  visitorObj.value = jmRes
  // console.log(visitorObj.value)
  // 判断是否显示审核
  if (gconfig.value.IsNeedCheck === 'True') {
    if (
      visitorObj.value.VisitorCheckSysstate === null ||
      visitorObj.value.VisitorCheckSysstate === '' ||
      visitorObj.value.VisitorCheckSysstate === '审核未通过'
    ) {
      showSh.value = true
      if (
        visitorObj.value.VisitorCheckSysstate === null ||
        visitorObj.value.VisitorCheckSysstate === ''
      ) {
        shContent.value = gconfig.value.WaitCheckContent
      } else {
        shContent.value = gconfig.value.CheckFailContent
      }
      return false
    } else {
      showSh.value = false
    }
  }
  if (gconfig.value.IsNeedIDCard === 'True') {
    // 是否需要补实名
    if (!visitorObj.value.VisitorIDCard) {
      // 如果没有身份证
      showVerCard.value = true
      formMg.value.Name = visitorObj.value.VisitorName
      return false
    }
    showVerCard.value = false
  }
  showSh.value = false
}
onMounted(() => {
  getMsg()
  if (isWeX.value) {
    wx.getWXSign()
  }
})
const showVerCard = ref(false)
const formMg = ref({
  Name: '',
  IDCardNo: ''
})
// 校验证件号
const validatorIDCardNo = (val) => {
  return regCId(val)
}
const rulesAll = ref({
  Name: [
    { required: true, validator: validatorName, message: '请输入正确的姓名' }
  ],
  IDCardNo: [{ validator: validatorIDCardNo, message: '请输入正确的身份证号' }]
})
// 表单验证失败
const onFailed = (errorInfo) => {
  console.log('failed', errorInfo)
}
const onSubmit = async (values) => {
  const res = await api.UpdateIDcardApi({
    VisitorID: VisitorID.value,
    Name: formMg.value.Name,
    IDCardNo: formMg.value.IDCardNo,
    exhcode: ExhCode.value
  })
  if (res.code === 200) {
    getMsg()
  }
}
const toMap = () => {
  router.push({ path: '/map' })
}
</script>
<style lang="less">
@import '../../assets/login.less';
.shConBox {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #f9f9f9;
  .shDiv {
    position: absolute;
    top: 35%;
    left: 50%;
    margin-top: -50%;
    margin-left: -40%;
    width: 80%;
    background: #fff;
    box-shadow: 0px 0px 10px #eee;
    border-radius: 10px;
    padding: 8vh 0 15vh;
    h3 {
      text-align: center;
      color: #18bae5;
      font-size: 16px;
      padding: 2vh 0;
    }
    img {
      width: 30%;
    }
    .shTxt {
      text-align: left !important;
      font-size: 14px;
      line-height: 28px;
      color: #000;
      padding: 0 5vw;
    }
  }
}
.topTxt {
  padding: 0 10px;
  p {
    padding: 6px 0;
    color: #323233;
    font-size: 14px;
  }
}
.iconbox {
  text-align: center;
  padding-top: 5vh;
  img {
    width: 42vw;
  }
}
.btnbox {
  text-align: center;
  padding: 2vh 0 0 0;
}
.tipsTxt {
  color: #2090be;
  font-weight: bold;
  padding-top: 20px;
}
.qrMain {
  text-align: center;
  padding-top: 20px;
  .qrbox {
    display: inline-block;
    // padding: 32px;
    border-radius: 6px;
    // box-shadow: 0px 0px 10px #ccc;
    .codeTip {
      font-size: 14px;
      color: #929396;
    }
  }
}
.attendMsg {
  padding: 3vw 2.6vw;
  background: #fff;
  width: 90%;
  margin: 10px auto;
  border-radius: 6px;
  > div {
    display: flex;
    align-items: flex-start;
    h3 {
      color: #58595b;
      font-size: 16px;
      text-align: left;
      padding-bottom: 3vw;
    }
    .iconImg {
      width: 7.2vw;
      padding: 0.8vw 2vw 0 0;
    }
  }
  .aTxt {
    text-align: left;
    padding-bottom: 2vw;
    span {
      color: #929396;
      font-size: 14px;
    }
  }
  .vMsg {
    border-bottom: 1px dashed #929396;
  }
  .eMsg {
    padding-top: 3vw;
  }
  .checkMap {
    padding: 3vw 0 0 7.2vw;
    b {
      font-size: 14px;
      color: #00469b;
      font-weight: normal;
    }
  }
}
.successConV2 {
  padding: 20px 0 30px;
  background: #fff;
  width: 90%;
  margin: 10px auto;
  border-radius: 6px;
  p,
  h3 {
    padding: 4px 0;
  }
  h3 {
    font-size: 26px;
  }
  .conname {
    font-size: 20px;
  }
}
.shMask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 2;
}
</style>
